import { render, staticRenderFns } from "./CondosPage.vue?vue&type=template&id=76d6b3e0&"
import script from "./CondosPage.vue?vue&type=script&lang=js&"
export * from "./CondosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d6b3e0')) {
      api.createRecord('76d6b3e0', component.options)
    } else {
      api.reload('76d6b3e0', component.options)
    }
    module.hot.accept("./CondosPage.vue?vue&type=template&id=76d6b3e0&", function () {
      api.rerender('76d6b3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/CondosPage.vue"
export default component.exports